export const interactionStudioApi = () => {
	return new Promise((res, rej) => {
		const clear = interval => {
			clearInterval(interval);
			interval = 0;
		};
		var started = Date.now();
		let interval = setInterval(() => {
			if (Date.now() - started > 3000) {
				console.log('Failed to find Interaction Studio API after 3 seconds');
				clear(interval);
				res(''); // timeout
			} else if (typeof oneCustomerAPI != 'undefined') {
				clear(interval);
				res(oneCustomerAPI);
			}
		}, 200);
	});
};
